import ErrorMessage from "./ErrorMessage";

interface ButtonProps {
  buttonLabel: string;
  errorMessage: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isLoading: boolean;
  showErrorMessage: boolean;
}

export default function Button(props: ButtonProps) {
  return (
    <div>
      <button
        className={`unsubscribe-button ${props.isLoading ? "loading" : ""}`}
        type="button"
        disabled={props.isLoading}
        onClick={props.onClick}
      >
        {props.isLoading ? (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          ""
        )}
        {props.buttonLabel}
      </button>
      {props.showErrorMessage ? <ErrorMessage errorMessage={props.errorMessage} /> : ""}
    </div>
  );
}
